;(function () {
    var palettes = {
        'primary': [{
            'background': '#205081',
            'border': '#104071'
        }, {
            'background': '#d04437',
            'border': '#c03427'
        }, {
            'background': '#f6c342',
            'border': '#e6b332'
        }, {
            'background': '#14892c',
            'border': '#04791c'
        }, {
            'background': '#707070',
            'border': '#606060'
        }, {
            'background': '#ebf2f9',
            'border': '#dbe2e9'
        }, {
            'background': '#3b73af',
            'border': '#2b639f'
        }, {
            'background': '#333333',
            'border': '#222222'
        }, {
            'background': '#a5a5a5',
            'border': '#959595'
        }],
        'secondary': [{
            'background': '#3b7fc4',    // Bright blue 2
            'border': '#2b6fb4'
        },{
            'background': '#ea632b',    // Orang
            'border': '#da531b'
        },{
            'background': '#999999',    // Gray
            'border': '#888888'
        },{
            'background': '#815b3a',    // Brown
            'border': '#714b2a'
        },{
            'background': '#f1a257',    // Tan
            'border': '#e19247'
        },{
            'background': '#d39c3f',    // Light brown
            'border': '#d38c2f'
        },{
            'background': '#4a6785',    // Slate
            'border': '#3a5775'
        },{
            'background': '#8eb021',    // Lime green
            'border': '#7ea011'
        },{
            'background': '#ac707a',    // Mauve
            'border': '#9c606a'
        },{
            'background': '#654982',    // Violet
            'border': '#553972'
        },{
            'background': '#7bc1a1',    // Emerald
            'border': '#6bb191'
        },{
            'background': '#f15c75',    // Bright Pink
            'border': '#e14c65'
        },{
            'background': '#f691b2',    // Pink
            'border': '#e681a2'
        },{
            'background': '#205081',
            'border': '#104071'
        }, {
            'background': '#d04437',
            'border': '#c03427'
        }, {
            'background': '#f6c342',
            'border': '#e6b332'
        }, {
            'background': '#14892c',
            'border': '#04791c'
        }]
    };

    function sep(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function formatNumber(number, decimalsLength, decimalSeparator, thousandSeparator) {
        var n = number,
            decimalsLength = isNaN(decimalsLength = Math.abs(decimalsLength)) ? 2 : decimalsLength,
            decimalSeparator = decimalSeparator == undefined ? "," : decimalSeparator,
            thousandSeparator = thousandSeparator == undefined ? "." : thousandSeparator,
            sign = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(decimalsLength)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;

        return sign +
            (j ? i.substr(0, j) + thousandSeparator : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandSeparator) +
            (decimalsLength ? decimalSeparator + Math.abs(n - i).toFixed(decimalsLength).slice(2) : "");
    }

    function MapChart(params) {
        $('#chart-countries').vectorMap({
            map: 'world_mill',
            backgroundColor: '#ffffff',
            zoomOnScroll: false,
            regionStyle: {
                initial: {
                    fill: '#aaaaaa'
                }
            },
            series: {
                regions: [{
                    values: params['data'],
                    scale: ['#FFAAAA', '#EE1111'],
                    normalizeFunction: 'polynomial'
                }]
            },
            onRegionTipShow: function (e, el, code) {
                count = params['data'][code] ? params['data'][code] : 0;
                el.html(CountriesList[code] + ' (' + sep(count) + ') ' + formatNumber(100/params['countries_total']*count, 2, '.', ' ') + '%');
            }
        });
    }

    function StatisticsChart(params) {
        this.element = document.getElementById(params['id']);

        this.options = params['options'] || {};
        this.options['scales'] = {
            yAxes: [{
                display: true,
                ticks: { 
                    callback: function (value) {
                        return formatNumber(value,0,'',' ');
                    }
                },
                position: 'left',
                id: 'y-axis-1',
            }]
        };
        if (params['multiAxis']) {
            this.options['scales'].yAxes.push({
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                    drawOnChartArea: false,
                },
                ticks: { 
                    callback: function (value) {
                        return formatNumber(value,0,'',' ');
                    }
                },
            });
        }
        if (params['formatNumberTooltips']) {
            this.options['tooltips'] = {
                callbacks: {
                    label: function(tooltipItem, data) {
                        return formatNumber(tooltipItem.yLabel,0,'',' ');
                    }
                }
            };
        }
        if (params['isPercents']) {
            this.options['scales']['yAxes'][0]['ticks']['max'] = 100;
        }

        if (params['legend']) {
            this.options['legend'] = { position: params['legend'] };
        } else {
            this.options['legend'] = { display: false };
        }

        if (params['title']) {
            this.options['title'] = {
                display: true,
                position: 'top',
                fontStyle: 'normal',
                text: params['title']
            };
        }

        if (params['type'] == 'bar' || params['type'] == 'pie') {
            params['data'] = [{ data: params['data'] }]
        }

        if (params['palette'] && palettes[params['palette']]) {
            switch (params['type']) {
                case 'line':
                    params['data'] = this.paletteLine(palettes[params['palette']], params['data']);
                    break;
                case 'bar':
                    params['data'] = this.paletteBar(palettes[params['palette']], params['data']);
                    break;
                case 'pie':
                    params['data'] = this.palettePie(palettes[params['palette']], params['data']);
                    break;
            }
        }
        if ( params['multiAxis'] ) {
            for (var i = 0; i < params['data'].length; i++) {
                if( params['data'][i].label == params['multiAxis'] )
                    params['data'][i].yAxisID = 'y-axis-2';
            }
        }
        this.obj = new Chart(this.element, {
            type: params['type'],
            options: this.options,
            data: {
                labels: params['labels'],
                datasets: params['data']
            }
        });
    }

    StatisticsChart.prototype = {
        paletteLine: function (palette, datasets) {
            for (var i = 0; i < datasets.length; i++) {
                datasets[i]['backgroundColor'] = palette[i]['background'];
                datasets[i]['borderColor'] = palette[i]['border'];
                datasets[i]['borderWidth'] = 2;
            }
            return datasets;
        },

        paletteBar: function (palette, datasets) {
            datasets[0]['backgroundColor'] = [];
            datasets[0]['borderColor'] = [];
            for (var i = 0, n = 0; i < datasets[0]['data'].length; i++, n++) {
                if (!palette[n]) n = 0;
                datasets[0]['backgroundColor'].push(palette[n]['background']);
                datasets[0]['borderColor'].push(palette[n]['border']);
            }
            return datasets;
        },

        palettePie: function (palette, datasets) {
            datasets[0]['backgroundColor'] = [];
            datasets[0]['hoverBackgroundColor'] = [];
            for (var i = 0, n = 0; i < datasets[0]['data'].length; i++, n++) {
                if (!palette[n]) n = 0;
                datasets[0]['backgroundColor'].push(palette[n]['background']);
                datasets[0]['hoverBackgroundColor'].push(palette[n]['border']);
            }
            return datasets;
        }
    };

    function Statistics2(charts) {
        this.charts = [];
        this.init(charts || []);
    }

    Statistics2.prototype = {
        init: function (charts) {
            for (var i = 0; i < charts.length; i++) {
                this.add(charts[i]);
            }
        },

        add: function (chart) {
            if (chart['type'] == 'map') {
                this.charts.push(new MapChart(chart));
            } else {
                this.charts.push(new StatisticsChart(chart));
            }
        }
    };

    window.Statistics2 = Statistics2;
}());